import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Button from '../styles/Button';

const OverlayStyles = styled.div`
    position: absolute;
    background: rgba(0, 0, 0, 0.4);
    color: #fff;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 4;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    h1 {
        margin: 25px 10px;
        max-width: 575px;
        text-align: center;
        text-shadow: 0 2px 6px rgba(0, 0, 0, 0.56);
    }
`;
const EmbedOverlay = ({ title, buttonTitle, buttonOnClick }) => (
    <OverlayStyles>
        <h1>{title}</h1>
        <Button variant="primary" onClick={buttonOnClick}>
            {buttonTitle}
        </Button>
    </OverlayStyles>
);

EmbedOverlay.propTypes = {
    title: PropTypes.string.isRequired,
    buttonTitle: PropTypes.string.isRequired,
    buttonOnClick: PropTypes.func.isRequired,
};

export default EmbedOverlay;
